// Imports
import makeParseNumber from './parseNumber.js'


// Prepare
const parseNumber = makeParseNumber()

// Export
export {
    parseNumber
}